import { HttpClient } from '@angular/common/http';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { IIntervallo } from 'app/model/ambulatorio';
import { IID } from 'app/model/id';
import { RESTObject } from '../angular-rest';

export interface IIntervallo {
	id?: number;
	inizio: NgbTimeStruct;
	fine: NgbTimeStruct;
  ambulatorio?: string;
}

export class Intervallo extends RESTObject<IIntervallo> implements IID<number> {

	id: number;

	constructor($http: HttpClient, uri: string, defaultValue: IIntervallo) {
		super($http, uri, defaultValue);
		this.id = defaultValue.id;
	}
}



// WEBPACK FOOTER //
// ./src/app/model/ambulatorio.ts